import GoogleAnalyticsEvent from 'dataTransferObjects/googleAnalyticsEvent';
import GoogleAnalyticsCustomDimensions from 'constants/googleAnalyticsCustomDimension';

const tdvEvents = 'TDV Events';

/* Creates a new instance for housing product type. */
export default class PlanProductType {
  constructor(listing) {
    this.brandName = listing.brandName;
    this.communityName = listing.communityName;
    this.id = listing.id;
    this.communityId = listing.communityId;
    this.isBasic = listing.isBasic === "true";
  }

  /**
   * This function returns a new GoogleAnalyticsEvent object with the event category, event action,
   * event label and custom dimensions set.
   * @returns A new instance of the GoogleAnalyticsEvent class for favorites.
   */
  getFavoriteGoogleAnalyticsEvent() {
    const customDimensions = { 
      [GoogleAnalyticsCustomDimensions.BrandName().getName()] :
      this.brandName,
      [GoogleAnalyticsCustomDimensions.CommunityName().getName()] :
      this.communityName,
      [GoogleAnalyticsCustomDimensions.PlanId().getName()] :
      this.id,
      [GoogleAnalyticsCustomDimensions.CommunityId().getName()] :
      this.communityId,
      [GoogleAnalyticsCustomDimensions.IsPaid().getName()] : 
      !this.isBasic,
    };
    return new GoogleAnalyticsEvent(tdvEvents, 'SRP Listing Card', 'Listing Saved', customDimensions);
  }
}
